import { Helmet } from "react-helmet";

const SITE_URL = "https://markdownconverter.online/";
const SITE_IMAGE = "https://markdownconverter.online/icons/md-converter-1024x1024.png";

export default function SEO() {
  const title = "Markdown Converter Pro - Free Online Markdown to PDF, DOCX & Google Docs";
  const description =
    "Convert Markdown to PDF, Word DOCX, and Google Docs instantly with real-time preview. Free online markdown editor with formatting toolbar, syntax highlighting, dark mode, and one-click export. No signup required.";
  const keywords =
    "markdown converter, markdown to pdf, markdown to word, markdown to docx, markdown to google docs, online markdown editor, free markdown converter, markdown preview, markdown export, convert markdown online, markdown formatting tool, document converter, md to pdf, md to docx";

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={SITE_URL} />
      <meta property="og:site_name" content="Markdown Converter Pro" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={SITE_IMAGE} />
      <meta property="og:image:width" content="1024" />
      <meta property="og:image:height" content="1024" />
      <meta property="og:image:alt" content="Markdown Converter Pro" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={SITE_IMAGE} />
      <meta name="twitter:image:alt" content="Markdown Converter Pro" />

      {/* Canonical */}
      <link rel="canonical" href={SITE_URL} />
    </Helmet>
  );
}
